import moment from 'moment';
import React, { Component } from 'react';
import DayPicker from 'react-day-picker';
// import "react-day-picker/lib/style.css";
import { getDisabledDates } from '../../selectors/date';
import { getLocationName } from '../../selectors/bookingLocation';
import DaySelector from '../SubComponents/DaySelector/DaySelector';
import Modal, { DefaultModalParams } from '../SubComponents/Modal/Modal';
import Footer from '../SubComponents/Footer/Footer';
import Header from '../SubComponents/Header/Header';
import toggleExtraLife from '../../utilities/specialFeatures.js';
import Popup from '../SubComponents/Popup/Popup';

import './DateSelection.css';
import './DayPicker.css';

export default class DateSelection extends Component {

  constructor(props) {
    super(props);

    // COVID 19 announcment modal suppression (from main website)
    const suppressPopupObj = window.localStorage.getItem('suppressbookingpopup');

    let suppressPopup = ( suppressPopupObj && typeof suppressPopupObj !== undefined);
    suppressPopup = suppressPopup && this.isLocationOpen(this.props.bookingLocation.locationId);
    //if not extra life
    this.state = {
      fullCalendar: false,
      modalOpen: false,
      modalParams: DefaultModalParams,

      screenResizeToggler: false,

      //EXTRA LIFE
      extraLifeValid: false,
      announcementModalOpen: !suppressPopup

    }

    this.onClickPrev = this.onClickPrev.bind(this);
    this.onClickNext = this.onClickNext.bind(this);
    this.inputFrozen = false;

    /*********************EXTRA LIFE FUNCTIONS********************/
    // this.getExtraLifeComponent = this.getExtraLifeComponent.bind(this);
    // this.resizeExtralife = this.resizeExtralife.bind(this);
    // this.handleExtraLifeClickDay = this.handleExtraLifeClickDay.bind(this);
    // this.checkTimesExist = this.checkTimesExist.bind(this);
  }

  isLocationOpen = (loc_id) =>{
    // RYAN HERE IT IS
    // THIS IS THE ARRAY
    const closedLocations = [];
    // ----------------
    if(closedLocations.includes(loc_id)){
      return false;
    }
    return true;
  }

  componentDidMount() {
    this.inputFrozen = false;
    // window.addEventListener("resize", this.resizeExtralife);

    // //EXTRA LIFE
    // if (toggleExtraLife()) {
    //   this.setState({
    //     extraLifeValid: this.checkTimesExist()
    //   })
    // }

    if (this.props.usedBookingLocalStorage) {
      //diable this from auto forwarding again
      this.props.disableUsedBookingLocalStorage();
      //autoforward
      this.props.proceedSequence();
      this.onClickNext();
    }
  }

  onClickNext() {
    if (!this.inputFrozen) {
      this.inputFrozen = true;

      // //check if extra life first
      // if (toggleExtraLife() && (moment(this.props.selectedDate).isSame(moment('2019-11-02'), 'day') || moment(this.props.selectedDate).isSame(moment('2019-11-03'), 'day'))) {
      //   if ((moment(this.props.selectedDate).isSame(moment('2019-11-02'), 'day'))) {
      //     this.handleExtraLifeClickDay(1);
      //   } else {
      //     this.handleExtraLifeClickDay(2);
      //   }
      // } else {
        this.props.transitionForward()
        this.inputFrozen = false;
      // }
    }
  }

  onClickPrev() {
    if (!this.inputFrozen) {
      this.props.transitionBack().catch((error) => {
        console.error('Failed to go back from date selection: ' + error);
      });
    }
  }

  onClickCalendar = () => {
    if (!this.inputFrozen) {
      this.setState({
        fullCalendar: !this.state.fullCalendar
      });
    }
  }

  //calendar click event
  handleDayClick = (day, { selected, disabled }) => {
    if (!this.inputFrozen) {
      if (disabled) return;
      if (selected) {
        this.props.selectDate(null);
        return;
      }
      this.props.selectDate(day);
      this.onClickNext();
    }
  }

  //scrollable container click event
  onSelectDay = day => {
    if (day.disabled === false && this.inputFrozen === false) {
      if (this.props.selectedDate && moment(this.props.selectedDate).isSame(day.date, 'day')) {
        this.props.selectDate(null);
      }
      else {
        this.props.selectDate(day.date.toDate());
      }
    }
  }

  onCloseModal = () => {
    this.setState({
      modalOpen: false
    }, () => {
      this.props.resetApp();
    });
  }

  openModal = (params) => {
    this.setState({
      modalOpen: true,
      modalParams: params
    });
  }

  getFullCalendar = () => {
    const { availableDates, selectedDate } = this.props;
    const furthestDate = availableDates.length > 0
      ? availableDates[availableDates.length - 1].toDate()
      : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return (
      <div className="DayPicker-Wrapper">
        {/* <div className={'DateSelection-calendarRow'}>
          <div className={'DateSelection-calendarBtn'} onClick={this.onClickCalendar}>
            <div className={'DateSelection-calendarIconWrapper'}>
              <img alt={'DateSelection-calendarIcon'} className={'DateSelection-calendarIcon'} src={`${process.env.PUBLIC_URL}/images/icons/CalendarIcon.png`} />
              {this.props.languageObj.close_calendar}
            </div>
          </div>
        </div> */}
        <DayPicker
          onDayClick={this.handleDayClick}
          selectedDays={selectedDate instanceof Date ? selectedDate : undefined}
          disabledDays={this.props.availableDates.length > 0
            ? getDisabledDates(this.props.availableDates)
            : [{ before: moment().toDate(), after: moment().toDate() }, moment().toDate()]}
          fromMonth={today}
          toMonth={furthestDate instanceof Date ? furthestDate : today}
          initialMonth={selectedDate instanceof Date ? selectedDate : undefined}
        />
      </div>
    );
  }

  getDayPicker = () => {
    const { availableDates } = this.props;
    const today = moment().hours(0).minutes(0).seconds(0).milliseconds(0);

    return (
      <div>
        <div className={'DateSelection-calendarRow'}>
          <div className={'DateSelection-calendarBtn'} onClick={this.onClickCalendar}>
            <div className={'DateSelection-calendarIconWrapper'}>
              <img alt={'DateSelection-calendarIcon'} className={'DateSelection-calendarIcon'} src={`${process.env.PUBLIC_URL}/images/icons/CalendarIcon.png`} />
              {this.props.languageObj.full_calendar}
            </div>
          </div>
        </div>
        <DaySelector
          fromMoment={today}
          toMoment={availableDates[availableDates.length - 1]}
          enabledDays={availableDates}
          selectedDay={this.props.selectedDate && moment(this.props.selectedDate)}
          handleSelectDay={this.onSelectDay}
          initialPageSize={3}
          saveSliderPosition={this.props.saveSliderPosition}
          initialSliderPosition={this.props.initialSliderPosition}
        />
      </div>
    );
  }

  /************************** EXTRA LIFE FEATURE ***************************/
//   getExtraLifeComponent() {

//     let style = {};
//     if (window.innerWidth >= 720) {
//       style = { backgroundImage: 'url("' + process.env.PUBLIC_URL + '/images/extra-life/book_window_background.png")' }
//     }
//     return (
//       <div className={'DateSelection-ExtraLifePanel'} >
//         <div className={'DateSelection-ExtraLifeBackground'} style={style}>
//           <div className={'DateSelection-PanelImage'} style={{ backgroundImage: 'url("' + process.env.PUBLIC_URL + '/images/extra-life/book_window_card.png"' }}>

//             <img alt={'ExtraLifeDates'} className={'DateSelection-Day1'} src={`${process.env.PUBLIC_URL}/images/extra-life/day1_icon.png`} onClick={(e) => {this.handleExtraLifeClickDay(1)}} />
//             <img alt={'ExtraLifeDates'} className={'DateSelection-Day2'} src={`${process.env.PUBLIC_URL}/images/extra-life/day2_icon.png`} onClick={(e) => {this.handleExtraLifeClickDay(2)}} />

//           </div>
//         </div>
//       </div>
//     )
//   }

//   resizeExtralife() {
//     this.setState({ screenResizeToggler: !this.state.screenResizeToggler });
//   }

//   handleExtraLifeClickDay(day_number) {
//     let day = (day_number===1)? moment("20191102", "YYYYMMDD"): moment("20191103", "YYYYMMDD");
//     this.props.selectDate(day.toDate());

//     this.props.setExtraLifeAutoComplete(true);
//     this.props.toggleExtraLife();
//     this.props.proceedExtraLife();
//   }

//   checkTimesExist() {
//     let date1 = moment('20191102').format("YYYY-MM-DD");
//     let date2 = moment('20191103').format("YYYY-MM-DD");
//     let date1_exists = this.props.availableDates.some(date => date.isSame(date1, 'day'));
//     let date2_exists = this.props.availableDates.some(date => date.isSame(date2, 'day'));

//     return date1_exists || date2_exists;
//   }

  renderAnnouncementsModal = () => {
    // debugger;
    if(this.isLocationOpen(this.props.bookingLocation.locationId)) return;
    const popupButton=(
        <div className="spanning warning-gradient"
        onClick={()=>{this.setState({announcementModalOpen:true})}}>
          Temporary Closure Due to COVID-19
        </div>
    );
    if(this.state.announcementModalOpen){
    return(
      <React.Fragment>
        {popupButton}
        <Popup closePopup={()=>{this.setState({announcementModalOpen:false})}}>
          <div className="padded">
            Ctrl V {getLocationName(this.props.bookingLocation)}
            {" "} is temporarily closed due to the recent
            situation involving the COVID-19 pandemic.
          </div>
          <div className="padded">
            Please subscribe to our newsletter and follow us on social media for the latest updates.
          </div>
          <div className="padded">
            We look forward to helping you escape reality again soon!
          </div>
          <div className="padded spanning">
            <a href={this.props.bookingLocation.country==="Canada"?"https://www.ctrlv.ca":"https://www.ctrlvarcade.com" } className="ctrlv-blue-button">
              Back to main site
            </a>
            <div className="ctrlv-blue-button" onClick={
              ()=>{
                this.setState({announcementModalOpen:false})
              }
            }>
              Book a Future Date
            </div>
          </div>
        </Popup>
      </React.Fragment>
    )
    }
    return popupButton;
  }

  render = () => {

    // let extraLifeComponent = null;
    // //if extra life event
    // if (toggleExtraLife() && this.state.extraLifeValid) {    //edit this line (! on this.state.extraLifeValid) when toggling extra life
    //   //if it is within time frame of extra life days
    //   extraLifeComponent = this.getExtraLifeComponent();
    // }

    return (
      <div className={'AppContainer'}>
        <Header
          header={this.props.bookingLocation ? getLocationName(this.props.bookingLocation).toLocaleUpperCase() : 'UNDEFINED LOCATION'}
          subHeader={this.props.languageObj.render.sub_header}
          slogan={this.props.languageObj.render.slogan}
          classNames={'Header-bottom'}
          hideOnMobile={true}
        />
        {this.renderAnnouncementsModal()}
        <div className={'DateSelection'}>
          {this.getFullCalendar()}
          {/****************************** EXTRA LIFE **************************/}
          {/* {extraLifeComponent} */}
        </div>
        <Modal
          isOpen={this.state.modalOpen}
          handleClose={this.onCloseModal}
          {...this.state.modalParams}
          modalType={0}
        />
        <Footer
          nextName={this.props.navPath === 'facility' ? this.props.languageObj.render.next_name_true : this.props.languageObj.render.next_name_false}
          prevName={this.props.languageObj.render.prev_name}
          nextDisabled={this.props.selectedDate === null}
          prevDisabled={false}
          handleClickNext={this.onClickNext}
          handleClickPrev={this.onClickPrev}
        />
      </div>
    );
  }



}
